import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { media } from '../../search-common/helpers'
import { fontFamilies, colors } from '../../search-common/settings'
import { translate } from '../../modules/helper-functions'

const Container = styled.div`
  padding-top: 18px;
`

const Title = styled.p`
  color: ${colors.gray};
  font-family: ${fontFamilies.aeonik};
  font-size: 14px;
  margin-bottom: 6px;
  font-weight: bold;
`

const LinkContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`

const LinkGroup = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  /* width: 100%; */
`

const Item = styled.li`
  cursor: pointer;
  display: inline-block;
  margin-right: 12px;
  margin-bottom: 12px;
`

const Link = styled.a`
  font-family: ${fontFamilies.aeonik};
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  border: 1px solid ${colors.white};
  color: ${colors.white};
  padding: 6px 12px;
  line-height: 28px;

  &:hover {
    background-color: ${colors.green};
    color: ${colors.grayTone1};
  }

  ${media.desktop`
    font-size: 16px;
  `}

  ${media.lDesktop`
    font-size: 18px;
  `}
`

/**
 * The QuickLinks component.
 */
class QuickLinks extends Component {

  /**
   *
   * @param {object} link
   */
  handleClick( link ) {
    const { doSearchQuery } = this.props
    return () => doSearchQuery( link )
  }

  /**
   * Render method.
   */
  render() {
    const { quickLinks, translations, getMenuProps, getItemProps } = this.props
    return (
      <Container>
        <Title>{translate( translations, 'Or chose an area' )}</Title>
        <LinkContainer>
          {quickLinks && quickLinks.map(( item, groupIndex ) => (
            <LinkGroup key={groupIndex} {...getMenuProps}>
              {item.link_group.links.map(( item, index ) => (
                <Item key={groupIndex + ' ' + index} {...getItemProps({
                  item,
                  index: ( `${groupIndex} ${index}` ),
                })}>
                  <Link >
                    {item.title}
                  </Link>
                </Item>
              ))}
            </LinkGroup>
            ))}
          </LinkContainer>
      </Container>
    )
  }
}

QuickLinks.propTypes = {
  quickLinks: PropTypes.array.isRequired,
  translations: PropTypes.object.isRequired,
  doSearchQuery: PropTypes.func.isRequired,
  getMenuProps: PropTypes.func.isRequired,
  getItemProps: PropTypes.func.isRequired,
}

export default QuickLinks
